export default "__VITE_ASSET__337d19f6__"